import t from "../../../../i18n";
import type { ColumnMetaData } from "@ui/Table/ColumnMetaData";
import type { FilterColumn, ParsedFilter } from "./types";
import { FilterProperties } from "./types";

const getLabel = (column: FilterColumn) => {
  switch (column) {
    case FilterProperties.QUANTITY:
      return t("project.filters.table.definitions.column.quantity");
    case FilterProperties.MAXIMUM_STD:
      return t("project.filters.table.definitions.column.max_std");
    case FilterProperties.MINIMUN_VALUE:
      return t("project.filters.table.definitions.column.min_value");
    case FilterProperties.MAXIMUM_VALUE:
      return t("project.filters.table.definitions.column.max_value");
    default:
      throw new Error(column satisfies never);
  }
};

const formatValueUnit = (value: number | null, unit: string | null) => {
  if (value !== null && unit !== null) {
    return `${value} ${unit}`;
  }

  return value;
};

const useMetadata = () => {
  const metadata: { [key in FilterColumn]: ColumnMetaData<ParsedFilter> } = {
    [FilterProperties.QUANTITY]: {
      label: getLabel(FilterProperties.QUANTITY),
      sticky: true,
      stickyBorder: true,
      sortable: true,
      render: filter => filter.name,
    },
    [FilterProperties.MINIMUN_VALUE]: {
      label: getLabel(FilterProperties.MINIMUN_VALUE),
      render: filter => formatValueUnit(filter.min, filter.unit),
      sortable: true,
    },
    [FilterProperties.MAXIMUM_VALUE]: {
      label: getLabel(FilterProperties.MAXIMUM_VALUE),
      render: filter => formatValueUnit(filter.max, filter.unit),
      sortable: true,
    },
    [FilterProperties.MAXIMUM_STD]: {
      label: getLabel(FilterProperties.MAXIMUM_STD),
      render: filter => formatValueUnit(filter.maxStd, filter.unit),
      sortable: true,
    },
  };

  return metadata;
};

export default useMetadata;
